"use strict";
var directives = angular.module('checkboxGroupDirective', []);
directives.directive("checkboxGroup", [function() {
  return {
    restrict: 'A',
    scope: {
      list: '=',
      index: '='
    },
    link: function($scope, elem, attrs) {
      var initClickHandler = function() {
        elem.bind('click', function() {
          if (elem[0].checked) {
            $scope.list.push($scope.index);
          } else {
            var index = $scope.list.indexOf($scope.index);
            $scope.list.splice(index, 1);
          }
        });
      };
      var init = function() {
        if (typeof $scope.list == 'undefined') {
          $scope.list = [];
        }
        for (var i = 0; i < $scope.list.length; i++) {
          if ($scope.list[i] == $scope.index) {
            elem[0].checked = true;
          }
        }
        initClickHandler();
      };
      init();
    }
  };
}]);
module.exports = directives;
